import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { IMultisiteItem } from '@df/core/service/multisite';
import { TimeoutService } from '@df/ng/timeout.service';
import { MultisiteSwitchComponentDef } from '@df/ui/multisite/multisite-switch.component.def';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { MultisiteFlagComponent } from '../../flag/multisite-flag.component';
import { TradeStoreService } from '../../trade/trade-store.service';
@Component({
    selector: 'multisite-switch-advanced',
    templateUrl: './multisite-switch-advanced.component.html',
    styleUrls: ['./../multisite-switch.component.scss'],
    standalone: true,
    imports: [TranslationModule, ToggleModule, MultisiteFlagComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultisiteSwitchAdvancedComponent extends MultisiteSwitchComponentDef {
    readonly toggleGroup = 'group';
    @Output()
    preferredStoreChange = new EventEmitter<void>();
    constructor(
        ref: ChangeDetectorRef,
        timeoutService: TimeoutService,
        private tradeStoreService: TradeStoreService,
        private toggleService: ToggleService
    ) {
        super(ref, timeoutService);
    }
    get sites(): IMultisiteItem[] {
        return this.tradeStoreService.isTradeStore() ? this.tradeStoreService.tradeSites : this.tradeStoreService.retailSites;
    }
    protected open(id: NToggle.TId): void {
        this.toggleService.open(id);
    }
    protected toggle(id: NToggle.TId): void {
        this, this.toggleService.toggle(id);
    }
    protected selectCurrency(site: IMultisiteItem): void {
        if (!this.isCurrent(site)) {
            this.multisiteRedirectService.to(site.id);
        } else {
            this.multisiteService.setPreferredStore(site.id);
            this.preferredStoreChange.emit();
        }
    }
}
